
import React from "react";

import Bellevi from "../../Clientes/Bellevi.png";
import Amanda from "../../Clientes/Amanda.png";
import Acilom from "../../Clientes/Acilom.png";
import CEC from "../../Clientes/CEC.png";
import PP from "../../Clientes/PP.png";
import Granja from "../../Clientes/Granja Morais.png";
import Rodage from "../../Clientes/Rodage.png";
import Comercial from "../../Clientes/Comercial Martins.png";
import CriativaFesta from "../../Clientes/Criativa Festas.png";
import Apiario from "../../Clientes/Apiario.png";
import CabecaoBaterias from "../../Clientes/Cabeção Baterias.png";
import BoloIdeal from "../../Clientes/Bolo Ideal.png";
import AMJoias from "../../Clientes/AM Joias.png";

const clientes = [
  { nome: "Bellevi", imagem: Bellevi },
  { nome: "Amanda Sobrancelhas", imagem: Amanda },
  { nome: "Acilom Frutas", imagem: Acilom },
  { nome: "CEC", imagem: CEC },
  { nome: "Colégio Pequeno Polegar", imagem: PP },
  { nome: "Granja Morais", imagem: Granja },
  { nome: "Auto Center Rodage", imagem: Rodage },
  { nome: "Comercial Martins Lemos", imagem: Comercial },
  { nome: "Criativa Festas", imagem: CriativaFesta },
  { nome: "Apiário de Rocha", imagem: Apiario },
  { nome: "Cabeção Baterias", imagem: CabecaoBaterias },
  { nome: "Bolo Ideal", imagem: BoloIdeal },
  { nome: "AM Joias", imagem: AMJoias },
];

function Parceiros() {
  return (
    <section id="parceiros" className="secao parceiros">
      <div className="container">
        <div className="parceiros-cabecalho">
          <div>
            <span className="sobretitulo">QUEM CONFIA NO NOSSO TRABALHO</span>
            <h2>
              Conexões que geram
              <span className="texto-destaque"> resultados.</span>
            </h2>
          </div>

          <p>
            Cada parceria representa uma oportunidade de transformar
            necessidades reais em soluções tecnológicas.
          </p>
        </div>

        <div className="clientes-grade">
          {clientes.map((cliente) => (
            <div className="cliente-item" key={cliente.nome}>
              <img
                src={cliente.imagem}
                alt={`Logotipo de ${cliente.nome}`}
                loading="lazy"
              />
              <span>{cliente.nome}</span>
            </div>
          ))}
        </div>

        <div className="parceiros-rodape">
          <span className="parceiros-ponto" />
          <p>
            Sua empresa também pode fazer parte dessa história.
          </p>
          <a href="#contato">
            Vamos conversar <span aria-hidden="true">↗</span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Parceiros;
